module.exports = __webpack_public_path__ + "img/arrow_up.f7fbd11b.svg";